import { SxProps, alpha, styled, useTheme } from '@mui/material';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch, { SwitchProps } from '@mui/material/Switch';
import * as Preact from 'preact';

export interface StyledSwitchProps extends SwitchProps {
    onChange: () => void;
    label?: string | Preact.ComponentChild;
    labelPlacement?: 'start' | 'end' | 'top' | 'bottom';
    size?: 'small' | 'medium';
    sx?: SxProps;
}

const StyledSwitch = styled(Switch)<SwitchProps>(({ theme }) => ({
    '& .MuiSwitch-switchBase': {
        color: theme.palette.background.default,
        '&:hover': {
            borderRadius: '50%',
            backgroundColor: alpha(theme.palette.primary.main, 0.1),
        },
    },
    '& .MuiSwitch-switchBase.Mui-checked': {
        color: theme.palette.primary.main,
        opacity: 1,
    },
}));

export const Component = (p: StyledSwitchProps) => {
    const theme = useTheme();
    return (
        <FormControlLabel
            control={
                <StyledSwitch
                    defaultChecked={p.defaultChecked}
                    checked={p.checked}
                    onChange={p.onChange}
                    size={p.size}
                    theme={theme}
                />
            }
            label={p.label || null}
            labelPlacement={p.labelPlacement}
            sx={{ margin: '0px', ...p.sx }}
        />
    );
};

Component.displayName = 'Switch';
